import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { SharedUtils } from 'src/app/modules/wino-shared/utilities/shared-utils';
import { environment } from 'src/environments/environment';
import { PermissionService } from '../../modules/wino-shared/services/permission.service';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.css']
})
export class NavBarComponent implements OnInit {

    permissionService: PermissionService;
    publishingModuleName: string = environment.publishingModuleName;
    libraryModuleName: string = environment.libraryModuleName;
    searchInput: string = '';

    @ViewChild('collapsibleNavbar', {static: true}) navbar: ElementRef;
    @ViewChild('collapsibleNavbarButton', {static: true}) navbarButton: ElementRef;

    isCollapsed: boolean = false;
    searchStringTooShort: boolean = false;
    
    constructor(private router: Router, permissionService: PermissionService) {
        this.permissionService = permissionService;
    }

    ngOnInit(): void {}

    onSearch() {
        if ( SharedUtils.inputValueIsEmpty(this.searchInput) ) {
            return;
        }
        if (this.searchInput.length < 4) {
            this.searchStringTooShort = true;
            return;
        }
        console.log(this.searchInput);
        this.router.navigateByUrl(`winoLibrary/entitySearch/${this.searchInput}`);
        this.searchInput = '';
    }

    articlesList() {

        this.navbar.nativeElement.ariaExpanded = false;
        this.navbarButton.nativeElement.ariaExpanded = false;
        this.navbar.nativeElement.ariaPressed = true;
        this.router.navigateByUrl('winoPublishing/articlesList');
    }

    createArticle() {
        this.router.navigateByUrl('winoPublishing/createArticle');
    }

    articlesApproveList() {
        this.router.navigateByUrl("winoPublishing/articlesApproveList");
    }

    postsList() {
        this.router.navigateByUrl('winoPublishing/postsList');
    }

    instagramMediaList() {
        this.router.navigateByUrl('winoPublishing/instagramGraphMediaList');
    }

    createPost() {
        this.router.navigateByUrl('winoPublishing/createPost');
    }

    postsApproveList() {
        this.router.navigateByUrl("winoPublishing/postsApproveList");
    }
}